export default __webpack_public_path__ + "static/media/AVAW55.da23217f.png";